<template>
  <div>
    <v-container fluid class="d-flex pa-0 fullHeight">
      <v-container class="container-custom px-6" fluid>
        <Breadcrumbs
          :title="$t('modules.examMassScheduling.table.breadcrumbs.title')"
          :description="$t('modules.examMassScheduling.table.breadcrumbs.description')"
        >
          <Button
            @clicked="tmpDrawerOpen"
            :icon="'mdi-plus'"
            :text="$t('actions.new')"
            depressed
          />
        </Breadcrumbs>
        <v-row justify="center">
          <v-col cols="12" class="viewSpaces">
            <SuperTable
              :headers="headers"
              :enrollments="enrollments"
              valid-as-icon
            />
          </v-col>
        </v-row>
        <TemporaryRightDrawer
          v-if="openedDrawer"
          @tmpDrawerOpen="tmpDrawerOpen"
          :open="tmpDrawer.open"
          :title="tmpDrawer.title"
          :description="tmpDrawer.description"
        >
          <MassImportExamSchedule
            :drawerOpen="tmpDrawer.open"
            @close="handleClose"
          />
        </TemporaryRightDrawer>
      </v-container>
    </v-container>
  </div>
</template>

<script>
import SuperTable from '../../../StudentMassEnrollment/Components/SuperTable/SuperTable';
import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs';
import Button from '@/components/Button/Button';
import TemporaryRightDrawer from '@/components/TemporaryRightDrawer/TemporaryRightDrawer';
import MassImportExamSchedule from '../Components/MassImportExamSchedule/MassImportExamSchedule.vue';

export default {
  name: 'ExamMassSchedulingTable',
  components: {
    SuperTable,
    Breadcrumbs,
    Button,
    TemporaryRightDrawer,
    MassImportExamSchedule,
  },
  data() {
    return {
      headers: [
        { text: this.$t('modules.examMassScheduling.table.headers.legajo'), value: 'legajo' },
        { text: this.$t('modules.examMassScheduling.table.headers.status'), value: 'error' },
      ],
      enrollments: [],
      tmpDrawer: {
        open: false,
        title: this.$t('modules.examMassScheduling.table.openDrawer.title'),
        description: this.$t('modules.examMassScheduling.table.openDrawer.subtitle'),
      },
      openedDrawer: true,
    };
  },
  methods: {
    tmpDrawerOpen() {
      this.tmpDrawer.open = !this.tmpDrawer.open;
    },
    handleClose(enrollments) {
      this.tmpDrawer.open = false;
      this.enrollments = enrollments && enrollments.length ? [...enrollments] : [];
    },
  },
};
</script>
